import * as moment from 'moment';
var Shrinkage = /** @class */ (function () {
    function Shrinkage(entity) {
        this.entity = entity;
        this.start = moment.duration(entity['Start']).asMilliseconds();
        this.finish = moment.duration(entity['Finish']).asMilliseconds();
    }
    Object.defineProperty(Shrinkage.prototype, "entityAspect", {
        get: function () {
            return this.entity.entityAspect;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shrinkage.prototype, "entityType", {
        get: function () {
            return this.entity.entityType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shrinkage.prototype, "FunctionKey", {
        get: function () {
            return this.entity['FunctionKey'];
        },
        set: function (value) {
            this.entity['FunctionKey'] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shrinkage.prototype, "DayOfWeek", {
        get: function () {
            return this.entity['DayOfWeek'];
        },
        set: function (value) {
            this.entity['DayOfWeek'] = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shrinkage.prototype, "Start", {
        get: function () {
            return this.start;
        },
        set: function (value) {
            this.start = value;
            this.entity['Start'] = moment.duration(value).toISOString();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shrinkage.prototype, "Finish", {
        get: function () {
            return this.finish;
        },
        set: function (value) {
            this.finish = value;
            this.entity['Finish'] = moment.duration(value).toISOString();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Shrinkage.prototype, "Value", {
        get: function () {
            return this.entity['Value'];
        },
        set: function (value) {
            this.entity['Value'] = value;
        },
        enumerable: true,
        configurable: true
    });
    return Shrinkage;
}());
export { Shrinkage };
